/**
 * Phase 19 — zero-load vector glyphs (web mirror of mobile). lucide
 * icons are already bundled + tree-shaken; no image downloads.
 */
import {
    Landmark, UtensilsCrossed, TreePine, Mountain, Moon, ShoppingBag,
    Waves, Palmtree, Crown, Sparkles, Building2, Compass,
} from "lucide-react";

const MAP = {
    cultural: Landmark, heritage: Landmark, spiritual: Sparkles,
    food: UtensilsCrossed, nature: TreePine, backwaters: TreePine,
    hills: Mountain, adventure: Mountain, nightlife: Moon,
    shopping: ShoppingBag, beach: Waves, island: Palmtree,
    luxury: Crown, city: Building2,
};

export default function CategoryGlyph({ name, size = 12, color = "#737373" }) {
    const key = String(name || "").trim().toLowerCase();
    const Icon = MAP[key] || Compass;
    return <Icon size={size} strokeWidth={2} color={color} />;
}
